import React from "react";
import Axios from "axios";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    //"Content-Type": "application/json",
    //"X-Requested-With": "XMLHttpRequest",
  },
});

export default axios;
